var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTabMineNormal = function SvgIconTabMineNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1245 6.74997C15.9408 9.22824 14.062 11.25 11.9995 11.25C9.93704 11.25 8.05502 9.22871 7.87455 6.74997C7.68705 4.17185 9.51517 2.24998 11.9995 2.24998C14.4839 2.24998 16.312 4.21873 16.1245 6.74997Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12C7.92197 12 3.78292 14.2499 3.01699 18.4968C2.92465 19.0087 3.21433 19.4999 3.75011 19.4999H20.2501C20.7863 19.4999 21.076 19.0087 20.9836 18.4968C20.2172 14.2499 16.0782 12 12.0001 12Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgIconTabMineNormal;